module.exports = __webpack_public_path__ + "static/Auckland-fireworks-82264159e1beb170fbe8b11c1ffb9158.jpg";